import K from '../constants';
import restHelpers from '../helpers/restHelper';

const getAllFn = () => restHelpers.withBearer.get(`${K.API_URL}/service-managers`, {});

const createFn = objectData =>
  restHelpers.withBearer.post(`${K.API_URL}/service-managers`, {
    data: {
      name: objectData.name,
      surname: objectData.surname,
      companyName: objectData.companyName,
      email: objectData.email,
      mobile: objectData.mobile,
      phone: objectData.phone,
      address: objectData.address,
      uin: objectData.uin
    }
  });

const updateFn = (serviceManagerId, apiData) => restHelpers.withBearer.put(`${K.API_URL}/service-managers/${serviceManagerId}`, { data: { ...apiData } });

const getAvailableAssetsWithActiveLeadFn = () => restHelpers.withBearer.get(`${K.API_URL}/dealers/assets-with-active-lead`, {});

const getServiceManagerAssetsFn = serviceManagerId => restHelpers.withBearer.get(`${K.API_URL}/dealers/service-managers/${serviceManagerId}/assets`, {});

const assignServiceManagerAssetsFn = (serviceManagerId, assetsIds) => restHelpers.withBearer.post(`${K.API_URL}/dealers/service-managers/${serviceManagerId}/assign-assets`, { data: { assets: assetsIds } });

const unassignServiceManagerAssetsFn = (serviceManagerId, assetsIds) => restHelpers.withBearer.post(`${K.API_URL}/dealers/service-managers/${serviceManagerId}/unassign-assets`, { data: { assets: assetsIds } });

export default {
  getAll: getAllFn,
  create: createFn,
  update: updateFn,

  getAvailableAssetsWithActiveLead: getAvailableAssetsWithActiveLeadFn,
  getServiceManagerAssets: getServiceManagerAssetsFn,
  assignServiceManagerAssets: assignServiceManagerAssetsFn,
  unassignServiceManagerAssets: unassignServiceManagerAssetsFn
};
